module.exports = __webpack_public_path__ + "img/36.bf8f7475.jpg";